import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cashRegisters: [],
    selectedCashRegister: null,
};

const cashRegisterSlice = createSlice({
    name: "cash_Register",
    initialState,
    reducers: { // ✅ Corrected: "reducers" instead of "reducer"
        setCashRegisters: (state, action) => {
            state.cashRegisters = action.payload;
        },
        setSelectedCashRegister: (state, action) => {
            state.selectedCashRegister = action.payload;
        }
    }
});

export const { setCashRegisters, setSelectedCashRegister } = cashRegisterSlice.actions;
export default cashRegisterSlice.reducer;
